import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=a673285e&scoped=true&"
import script from "./Support.vue?vue&type=script&lang=ts&"
export * from "./Support.vue?vue&type=script&lang=ts&"
import style0 from "./Support.vue?vue&type=style&index=0&id=a673285e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a673285e",
  null
  
)

export default component.exports